'use client';

import { useState, useCallback } from 'react';
import { adminKycApi } from '../api';
import type { DeleteResponse } from '../types';

interface UseDeleteDocumentReturn {
  deleteDocument: (documentId: string, tenantSlug: string, clientId: string) => Promise<DeleteResponse>;
  isLoading: boolean;
  error: string | null;
  reset: () => void;
}

export function useDeleteDocument(): UseDeleteDocumentReturn {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteDocument = useCallback(
    async (documentId: string, tenantSlug: string, clientId: string): Promise<DeleteResponse> => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await adminKycApi.deleteDocument(documentId, tenantSlug, clientId);
        return response;
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Failed to delete document';
        setError(errorMessage);
        throw err;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  const reset = useCallback(() => {
    setIsLoading(false);
    setError(null);
  }, []);

  return { isLoading, error, deleteDocument, reset };
}
